import "core-js/modules/es.number.constructor.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "flex flex-col gap-0 w-full"
};
var _hoisted_2 = {
  class: "flex flex-col"
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  class: "flex flex-col items-end"
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  key: 1
};
import { computed } from "vue";
import { getDateFromWeek } from "@/composables/useWeeklyDateRange.ts";
import Skeleton from "primevue/skeleton";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { useI18n } from "vue-i18n";
export default {
  __name: 'WeeklyCols',
  props: {
    interval: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(__props) {
    dayjs.extend(isBetween);
    var _useI18n = useI18n(),
      locale = _useI18n.locale;
    var props = __props;
    var year = computed(function () {
      return props.interval.split("-")[0];
    });
    var week = computed(function () {
      return Number(props.interval.split("-W")[1]);
    });
    var formatDate = function formatDate(date) {
      return dayjs(date, "YYYY.MM.DD", locale.value).format("DD MMM").toUpperCase();
    };
    var fromDate = computed(function () {
      if (!week.value || !year.value) return {
        day: "",
        month: ""
      };
      var date = formatDate(getDateFromWeek(week.value, year.value));
      return {
        day: date.split(" ")[0],
        month: date.split(" ")[1]
      };
    });
    var toDate = computed(function () {
      if (!week.value || !year.value) return {
        day: "",
        month: ""
      };
      var startDate = getDateFromWeek(week.value, year.value);
      startDate.setDate(startDate.getDate() + 6);
      var date = formatDate(startDate);
      return {
        day: date.split(" ")[0],
        month: date.split(" ")[1]
      };
    });
    var isTodayBetweenFromAndTo = computed(function () {
      if (!week.value || !year.value) return false;
      var startDate = getDateFromWeek(week.value, year.value);
      var endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);
      var today = dayjs();
      var weekStart = dayjs(startDate);
      var weekEnd = dayjs(endDate);
      return today.isBetween(weekStart, weekEnd, "day", "[]");
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["min-w-[100px] h-[40px] flex items-center justify-between border-surface-100 text-xs font-semibold border-r px-1 text-primary-300", {
          '!text-primary-600 !bg-primary-200': isTodayBetweenFromAndTo.value
        }])
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px",
        class: "mb-1"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(fromDate.value.day), 1))]), _createElementVNode("div", null, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fromDate.value.month), 1))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px",
        class: "mb-1"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(toDate.value.day), 1))]), _createElementVNode("div", null, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(toDate.value.month), 1))])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["min-w-[100px] h-[28px] flex items-center justify-center border-surface-100 text-sm font-semibold border border-l-0 border-b-0 text-surface-400", {
          '!text-primary-600 !bg-primary-200': isTodayBetweenFromAndTo.value
        }])
      }, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(locale) === "hu" ? "H" : "W") + " " + _toDisplayString(week.value), 1))], 2)]);
    };
  }
};